import { render, staticRenderFns } from "./SLong.vue?vue&type=template&id=e32d5f24&scoped=true"
import script from "./SLong.vue?vue&type=script&lang=js"
export * from "./SLong.vue?vue&type=script&lang=js"
import style0 from "./SLong.vue?vue&type=style&index=0&id=e32d5f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32d5f24",
  null
  
)

export default component.exports